module.exports = __webpack_public_path__ + "static/video-0881557a1e415e1836c93cd963293296.mp4";